angular.module('mtic')
.service('ModuleFilter', function (LocaleService, PlatformService) {

  var modules = {};
  var ModuleFilter = {};

  var availableOnBranch = function (module) {
    // window.console.log('-----')
    if (module.content && module.content.lock_on) {
      for (var i = 0; i < module.content.lock_on.length; i++) {
        var currentLock = module.content.lock_on[i];
        if (LocaleService.checkUrlVersion(currentLock)) {
          modules[module.slug].availableOnBranch = false;
          return false;
        }
      }
    }
    modules[module.slug].availableOnBranch = true;

    return modules[module.slug].availableOnBranch;
  }

  var isNeedsFlashReported = false; // only do this once
  var reportNeedsFlash = function(){
    if (!isNeedsFlashReported){
      isNeedsFlashReported = true;
      window.alert('The Cycle 4 modules are not currently available on iPad/Android. They are under maintenance which will be completed in mid-September. In the interim, please use the lessons on a laptop or desktop computer.')
    }
  }

  var availableOnDevice = function (module) {
    var isAvailable = PlatformService.supportsFlash || !(module.content && module.content.needs_flash);
    modules[module.slug].availableOnDevice = isAvailable;
    if (!isAvailable){
      reportNeedsFlash()
    }
    return isAvailable;
  }

  ModuleFilter.checkAvailable = function (module) {
    if (!modules[module.slug]) {
      modules[module.slug] = {};
      availableOnBranch(module)
      availableOnDevice(module)
    }

    return modules[module.slug].availableOnBranch && modules[module.slug].availableOnDevice;
  }

  ModuleFilter.checkNotificationAvailable = function(notification_state){
    if (notification_state && notification_state.hide_on) {
      for (var i = 0; i < notification_state.hide_on.length; i++) {
        var currentLock = notification_state.hide_on[i];
        if (LocaleService.checkUrlVersion(currentLock)) {
          return false;
        }
      }
    }
    return true;
  }



  return ModuleFilter;
});
